export class ResultItemFlexType {
  static readonly RESULT_ITEM_CERTIFICATES = 'result_item_certificates'
  static readonly RESULT_ITEM_CLINICAL_CHANGES = 'result_item_clinical_changes'
  static readonly RESULT_ITEM_CONTENT = 'result_item_content'
  static readonly RESULT_ITEM_FAQ = 'result_item_faq'
  static readonly RESULT_ITEM_JOB = 'result_item_job'
  static readonly RESULT_ITEM_VIDEO = 'result_item_video'
  static readonly RESULT_ITEM_DOCUMENT = 'result_item_document'
}
